// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CategoryPage_CategoryPage__pvw6V .CategoryPage_BackButton__WdCuQ {
  margin: 0 0 10px;
}
.CategoryPage_CategoryPage__pvw6V .CategoryPage_Button__iVdl7 {
  margin: 30px 0 0;
}`, "",{"version":3,"sources":["webpack://./src/components/CategoryPage/CategoryPage.module.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;AAAR;AAGI;EACI,gBAAA;AADR","sourcesContent":[".CategoryPage {\n    .BackButton {\n        margin: 0 0 10px;\n    }\n\n    .Button {\n        margin: 30px 0 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"CategoryPage": `CategoryPage_CategoryPage__pvw6V`,
	"BackButton": `CategoryPage_BackButton__WdCuQ`,
	"Button": `CategoryPage_Button__iVdl7`
};
export default ___CSS_LOADER_EXPORT___;
